import { UserRoutes } from '~config/routes'

export const DARK_BACKGROUND_PAGES = [
    UserRoutes.DailyHuddle,
    UserRoutes.Chats,
    UserRoutes.TeamChat,
    UserRoutes.Appointments,
    UserRoutes.Audiences,
    UserRoutes.EnterpriseStandardizationAudienceDetails(''),
    UserRoutes.ClientsPatients,
    UserRoutes.AudienceDetails(''),
    UserRoutes.ClientDetails(''),
    UserRoutes.PatientDetails(''),
    UserRoutes.PrescriptionRefillRequests,
]

export const EXCLUDED_DARK_BACKGROUND_PAGES = [
    '/engagement/audiences/edit/',
    '/engagement/audiences/new',
]
